'use strict';

$(document).ready(function () {
    window.$window = $(window);

    var assets = ['./assets/img/header_01.jpg', './assets/img/header_02.jpg', './assets/img/header_03.jpg', './assets/img/header_04.jpg'];

    var min_load_time = 0; //ms
    var starttime = Date.now();

    function preLoad() {
        var preload = new createjs.LoadQueue();
        preload.addEventListener("fileload", function () {
            //initApp();
        });

        assets.forEach(function (url) {
            preload.loadFile(url);
        });

        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = './assets/css/app.bundle.css?v=1.0';
        css.type = 'text/css';
        var godefer = document.getElementsByTagName('link')[0];
        godefer.parentNode.insertBefore(css, godefer);
    }

    //preLoad();

    initApp();

    function initApp() {
        var timeleft = min_load_time - (Date.now() - starttime);

        timeleft = timeleft < 0 ? 0 : timeleft;

        console.log(timeleft);

        setTimeout(function () {
            $('body').removeClass('loading');
            $('#loader > *').remove();
            TweenMax.set('#loader', { opacity: 1, display: 'block' });
            TweenMax.set('#app', { opacity: 0 });
            TweenMax.to('#loader', 0.1, { opacity: 0, onComplete: function onComplete() {
                    TweenMax.set('#loader', { display: 'none' });
                    TweenMax.to('#app', 0.5, { opacity: 1 });

                    initPhotoFeed();
                    initButtons();
                    initStickyMenu();

                    $('select').select2({
                        minimumResultsForSearch: Infinity
                    });

                    $('select.language-switcher').change(function (e) {
                        window.location = $(e.target).val();
                    });

                    if ($('#collection').length != 0) {
                        collection.init();
                        return;
                    }

                    if ($('#collection-detail--header').length != 0) {
                        collection.initDetailPage();
                        return;
                    }

                    // init home
                    if ($('#slideContainer').length > 0) {
                        var homepage = new Home();

                        homepage.animateIn();
                        homepage.setScene();

                        $(window).resize(function () {
                            homepage.setScene();
                        });
                    }
                } });
        }, timeleft);
    }
});

function initButtons() {
    //  step down button

    $('#menu-button').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('body').toggleClass('menu-open');
    });

    $('.gender-select a').click(function (e) {
        e.preventDefault();

        var gender = $(e.target).attr('href').slice(1);

        $('#looks article').hide();
        $('#looks article.looks--' + gender).show();
    });

    $('#left-nav a, .smooth_scroll').click(function (e) {
        e.preventDefault();
        var target_id = e.currentTarget.getAttribute("href");

        var scroll = parseInt($(target_id).offset().top) - $('#header').outerHeight();

        TweenMax.to(window, 1, { scrollTo: { y: scroll, autoKill: false }, onComplete: function onComplete() {} });
    });

    $('.collapsable-list li h3').click(function (e) {
        var target = $(e.currentTarget).parent();
        if (target.hasClass('active')) {
            target.removeClass('active');
        } else {
            $('.collapsable-list li').removeClass('active');
            target.addClass('active');
        }
    });
}

function initStickyMenu() {
    var $targetEl = $('#left-nav-container--content');

    if ($targetEl.length == 0) return;

    var nav_height = $('#left-nav').outerHeight();
    var controllerSticky = new ScrollMagic.Controller();

    var duration = $targetEl.outerHeight() - nav_height + 20;
    console.log(duration);

    var offsets = [];

    // get offsets
    var sections = $('#left-nav a');
    sections.each(function () {
        var section = $($(this).attr('href'));

        offsets.push(section.offset().top - 150);
    });

    var $indicator = $('#left-nav .indicator');

    var offset = $window.height() / 2 - nav_height / 2;

    new ScrollMagic.Scene({
        triggerElement: "#left-nav-container--content",
        offset: -offset,
        triggerHook: "onLeave",
        duration: duration
    }).setPin("#left-nav").setClassToggle("#left-nav", "bottom") // add class toggle
    .on("progress", function (e) {
        var index;

        var scrollTop = $(window).scrollTop();

        $indicator.height('' + e.progress * 100 + '%');

        for (var i = 0; i < offsets.length; i++) {
            index = 0;
            var top = offsets[i];
            var bottom = offsets.length > i + 1 ? offsets[i + 1] : 9999999999;

            if (scrollTop > top && scrollTop < bottom) {
                index = i;
                break;
            }
        }

        $('#left-nav li').removeClass('active');
        $('#left-nav li').eq(index).addClass('active');
    }).addTo(controllerSticky);
}

window.isAnimating = false;

function setAnimating(bool) {
    if (window.touchMove) bool = false;

    window.isAnimating = bool;
    console.log(bool);

    if (bool) {
        $(document).on('touchmove', function (e) {
            e.preventDefault();
        });
    } else {
        $(document).off('touchmove');
    }
}

function setAnimatingxx(bool) {
    window.isAnimating = bool;

    if (bool) {
        disableScroll();
    } else {
        enableScroll();
    }
}

// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {
    32: 1, 33: 1, 34: 1, 35: 1, 36: 1,
    37: 1, 38: 1, 39: 1, 40: 1
};

function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault) e.preventDefault();
    e.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
    return null;
}

function disableScroll() {
    $('body').css('touch-action', 'none');
    // $('#scroll-disabler').show();

    if (window.addEventListener) // older FF
        window.addEventListener('DOMMouseScroll', preventDefault, false);
    window.onwheel = preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE

    window.ontouchmove = preventDefault; // mobile

    document.onkeydown = preventDefaultForScrollKeys;
}

function enableScroll() {

    $('body').css('touch-action', 'inherit');
    // $('#scroll-disabler').hide();


    if (window.removeEventListener) window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;

    document.onkeydown = null;
    window.ontouchmove = null;

    // initSmoothScroll();

    // document.body.addEventListener('touchmove', function(e){
    //     // var touchobj = e.changedTouches[0] // reference first touch point for this event
    //     // var dist = parseInt(touchobj.clientX) - startx;
    //     // handle(dist);
    //     // e.preventDefault();
    // }, false);
}
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var controller = null;
var scene = null;
var tl = null;
var mobileWidth = 780;
var state = null; //'desktop';
var currentStep = 1;
var touchMove = false;

var Home = function () {
    function Home() {
        _classCallCheck(this, Home);

        this.initButtons();
    }

    _createClass(Home, [{
        key: "animateIn",
        value: function animateIn() {
            window.scrollTo(0, 0);

            // window.onbeforeunload = function () {
            //     window.scrollTo(0, 0);
            // };

            setAnimating(true);
            tl = new TimelineMax({ onComplete: function onComplete() {
                    setAnimating(false);
                } });

            var start = 0;

            tl.set("#header_01", { zIndex: 3, opacity: 1 }).fromTo("#header_01" + " .img", 0.5, { x: "120%" }, { x: "0%" }, start).from("#header_01" + " h1", 0.3, { y: -200, opacity: 0 }, start + 0.4).from("#header_01" + " .text", 0.3, { x: "-100%" }, start + .6).from("#header_01" + " .number", 0.2, { x: -250 }, start + .8).from("#scroll_down", 1, { bottom: '+=100', opacity: 0, ease: Bounce.easeOut }, start + .8).from("#indicator, #view-the-looks", 0.3, { opacity: 0 }, start + .8);
            ;
            // TweenMax.from("#scroll_down", 1, {
            //      //x: '-=50', // Tween to the current x value minus 50
            //      marginBottom: '+=240', // Tween to the current y value plus 50
            //      ease:Elastic.easeOut.config(1, 0.3)
            //  });
        }
    }, {
        key: "setScene",
        value: function setScene() {
            if ($('#slideContainer').length == 0) return;

            if (window.innerWidth < mobileWidth) {
                if (state == 'desktop') {
                    window.location = window.location;
                }
                if (state != 'mobile') {
                    this.destroyScrollMagic();
                    this.initScrollMagicMobile();
                    //initScrollMagicCollection();
                }
                state = 'mobile';
            } else {
                if (state == 'mobile') {
                    window.location = window.location;
                }
                if (state != 'desktop') {
                    this.destroyScrollMagic();
                    this.initScrollMagic();
                    this.initSmoothScroll();
                }
                state = 'desktop';
            }
        }
    }, {
        key: "initSmoothScroll",
        value: function initSmoothScroll() {
            var self = this;

            /*
            TOUCH
             */
            var touchStart = 0;
            var touchCurrentStep = 1;

            $(window).on('touchstart', function () {
                touchStart = $window.scrollTop();
                console.log(touchStart);
                touchMove = true;
            });
            $(window).on('touchend', function () {
                var touchEnd = $window.scrollTop();
                console.log(touchEnd);

                var delta = touchStart - touchEnd;

                if (delta > 0) {
                    console.log('go2');

                    if (touchCurrentStep > 1) {
                        self.scrollToStep(touchCurrentStep - 1);
                        touchCurrentStep -= 1;
                        return;
                    }
                } else {
                    console.log('go3');
                    console.log(touchCurrentStep);

                    if (touchCurrentStep < 5) {
                        self.scrollToStep(touchCurrentStep + 1);
                        touchCurrentStep += 1;
                        return;
                    }
                }
            });

            if (window.addEventListener) window.addEventListener('DOMMouseScroll', wheel, false);
            window.onmousewheel = document.onmousewheel = wheel;

            // ignore scroll when on scrollable element
            $('ul.stores').on('mousewheel', function (e) {
                e.stopPropagation();
            });

            function wheel(event) {
                if (window.isAnimating) {
                    if (event.preventDefault) event.preventDefault();
                    event.returnValue = false;
                    return;
                }

                var delta = 0;
                if (event.wheelDelta) delta = event.wheelDelta / 120;else if (event.detail) delta = -event.detail / 3;

                //

                handleSnapScroll(delta);
                //return;

                if (event.preventDefault) event.preventDefault();
                event.returnValue = false;
            }

            var goUp = true;
            var end = null;
            var interval = null;

            function handleSnapScroll(delta) {
                var scrollPosition = $window.scrollTop();
                var section_header_height = $('.scrollmagic-pin-spacer').eq(0).innerHeight();

                if (scrollPosition < section_header_height * (2 / 3)) {
                    console.log('go');

                    if (delta > 0) {
                        if (window.currentStep > 1) {
                            self.scrollToStep(window.currentStep - 1);
                            return;
                        }
                    } else {
                        if (window.currentStep < 4) {
                            self.scrollToStep(window.currentStep + 1);
                            return;
                        }
                    }
                } else {
                    handle(delta);
                }
            }

            function handle(delta) {
                var animationInterval = 10; //lower is faster
                var scrollSpeed = 10; //lower is faster

                if (end == null) {
                    end = $(window).scrollTop();
                }
                end -= 20 * delta;
                goUp = delta > 0;

                if (interval == null) {
                    interval = setInterval(function () {
                        var scrollTop = $(window).scrollTop();
                        var step = Math.round((end - scrollTop) / scrollSpeed);
                        if (scrollTop <= 0 || scrollTop >= $(window).prop("scrollHeight") - $(window).height() || goUp && step > -1 || !goUp && step < 1) {
                            clearInterval(interval);
                            interval = null;
                            end = null;
                        }
                        $(window).scrollTop(scrollTop + step);
                    }, animationInterval);
                }
            };
        }
    }, {
        key: "destroyScrollMagic",
        value: function destroyScrollMagic() {
            if (controller == null) return;

            controller.destroy(true);
            if (tl != null) tl.clear();

            controller = null;
            scene = null;
            tl = null;

            $('.right, .number, h1, p').css("transform", "");
            $('.right, .number, h1, p').css("opacity", "");
        }
    }, {
        key: "initScrollMagic",
        value: function initScrollMagic() {
            var pauze = 1;

            controller = new ScrollMagic.Controller({
                // globalSceneOptions: {
                //     triggerHook: 'onLeave'
                // }
            });

            var t_h01_start = 0;
            var t_h02_start = 1 + pauze;
            var t_h03_start = t_h02_start + 1 + pauze;

            // var contentStartTop = "30%";

            tl = new TimelineMax();
            // .set("#header_01", {zIndex: 3})
            // .set("#header_02", {zIndex: 2});
            // .set("#header_01 .content", {top: contentStartTop});

            tl = this.addSectionAnimation(tl, "#header_01", "#header_02", t_h01_start);

            tl = this.addSectionAnimation(tl, "#header_02", "#header_03", t_h02_start);
            tl = this.addSectionAnimation(tl, "#header_03", "#header_04", t_h03_start);

            // bind to scene
            var $indicators = $('#indicator > span');
            var $indicatorCounter = $('#indicator--counter');

            var $downButton = $('#scroll_down');
            // create scene to pin and link animation
            new ScrollMagic.Scene({
                triggerElement: "#pinContainer",
                triggerHook: "onLeave",
                duration: "200%"
            }).setPin("#pinContainer").setTween(tl).on("progress", function (e) {
                var index;
                if (e.progress < 0.1) {
                    index = 0;
                    window.currentStep = 1;
                } else if (e.progress < 0.43) {
                    index = 1;
                    window.currentStep = 2;
                } else if (e.progress < 0.75) {
                    index = 2;
                    window.currentStep = 3;
                } else {
                    index = 3;
                    window.currentStep = 4;
                }

                $indicators.removeClass('active');
                $indicators.eq(index).addClass('active');
                $indicatorCounter.html('0' + window.currentStep);
            }).addTo(controller);

            // new ScrollMagic.Scene({triggerElement: "#collection", offset: 10, triggerHook: "onLeave"})
            //     .setPin("#pin-on-top")
            //     .setClassToggle("#pin-on-top", "transparent") // add class toggle
            //     .addTo(controller);


            // new ScrollMagic.Scene({triggerElement: "#collection", offset: -57, triggerHook: "onLeave",})
            //     .setClassToggle("#logo-dark", "show") // add class toggle
            //     .addTo(controller);
        }
    }, {
        key: "addSectionAnimation",
        value: function addSectionAnimation(tl, section_out, section_in, start) {
            var sections = ['#header_01', '#header_02', '#header_03', '#header_04'];

            var index = sections.indexOf(section_out);
            sections.splice(index, 1);
            index = sections.indexOf(section_in);
            sections.splice(index, 1);

            tl.set(sections, { zIndex: 1, opacity: 0 })
            // .set("#header_02", {zIndex: 1})
            // .set("#header_03", {zIndex: 1})
            // .set("#header_04", {zIndex: 1})
            .set(section_out, { zIndex: 2, opacity: 1 }).set(section_in, { zIndex: 3, opacity: 1 }).to(section_out + " .number", 0.2, { x: -250 }, start).to(section_out + " h1", 0.3, { y: -200, opacity: 0 }, start + 0.03)
            // .to(section_out + " p", 0.1, {opacity: 0, y: 100}, start + 0.03)
            .to(section_out + " .text", 1, { x: "-100%" }, start + 0.1).to(section_out + " .img", 0.3, { x: "120%", ease: Power1.easeIn }, start + 0.2)

            //h3: animate text in
            // .set(section_in, {zIndex: 3}, start + 1.1)
            .fromTo(section_in + " .img", 1, { x: "120%" }, { x: "0%" }, start + 0.2).from(section_in + " .number", 0.2, { x: -250 }, start + 0.1).from(section_in + " h1", 0.3, { y: -200, opacity: 0 }, start + 0.8).from(section_in + " .text", 0.3, { x: "-100%" }, start + 1.1);
            // .from(section_in + " p", 0.1, {opacity: 0, y: 50}, start + 1.1);


            return tl;
        }
    }, {
        key: "initScrollMagicMobile",
        value: function initScrollMagicMobile() {
            controller = new ScrollMagic.Controller();

            // var slides = document.querySelectorAll(".pane");
            //
            // // create scene for every slide
            // for (var i=0; i<slides.length; i++) {
            //     new ScrollMagic.Scene({
            //         triggerElement: slides[i],
            //         triggerHook: 'onLeave'
            //     })
            //         .setPin(slides[i])
            //        // .addIndicators() // add indicators (requires plugin)
            //         .addTo(controller);
            // }

            var $indicators = $('#indicator span');
            var $indicatorCounter = $('#indicator--counter');

            new ScrollMagic.Scene({ triggerElement: "#pinContainer", offset: 0, triggerHook: "onLeave" }).on("update", function (e) {
                var progress = e.scrollPos / $('#pinContainer').outerHeight();
                console.log(progress);

                var index;
                if (progress < 0.22) {
                    index = 0;
                    window.currentStep = 1;
                } else if (progress < 0.45) {
                    index = 1;
                    window.currentStep = 2;
                } else if (progress < 0.70) {
                    index = 2;
                    window.currentStep = 3;
                } else if (progress < 1) {
                    index = 3;
                    window.currentStep = 4;
                    //$("#pinContainer, #indicator, #scroll_down").removeClass('hide');
                } else {
                        //$("#pinContainer, #indicator, #scroll_down").addClass('hide');
                    }

                $indicators.removeClass('active');
                $indicators.eq(index).addClass('active');
                $indicatorCounter.html('0' + window.currentStep);
            }).addTo(controller);
        }
    }, {
        key: "initButtons",
        value: function initButtons() {
            var self = this;
            $('#scroll_down').click(function (e) {
                // e.preventDefault();

                switch (window.currentStep) {
                    case 1:
                        self.scrollToStep(2);
                        break;
                    case 2:
                        self.scrollToStep(3);
                        break;
                    case 3:
                        self.scrollToStep(4);
                        break;
                    case 4:
                        self.scrollToStep(5);
                        break;
                }
            });

            $('#indicator span, #view-the-looks').click(function (e) {
                e.preventDefault();

                self.scrollToStep($(e.target).data('step'));
            });
        }
    }, {
        key: "scrollToStep",
        value: function scrollToStep(step) {
            if (window.isAnimating) return;

            var scroll;
            var speed = 1.5 * 0.4;
            var stepHeight;
            var stepHeights = [];

            if (window.innerWidth < mobileWidth) {
                stepHeight = $(window).height();
                // stepHeights[1] = stepHeight * (1);
                // stepHeights[2] = stepHeight * (3);
                // stepHeights[3] = stepHeight * (5);
                // stepHeights[4] = stepHeight * (7);
                stepHeights[1] = "#header_01";
                stepHeights[2] = "#header_02";
                stepHeights[3] = "#header_03";
                stepHeights[4] = "#header_04";
                stepHeights[5] = "#looks";
            } else {
                stepHeight = $('.scrollmagic-pin-spacer').eq(0).innerHeight();
                stepHeights[1] = stepHeight * 0;
                stepHeights[2] = stepHeight * 0.222222;
                stepHeights[3] = stepHeight * 0.444444;
                stepHeights[4] = stepHeight * (2 / 3);
                stepHeights[5] = "#looks";
            }

            setAnimating(true);

            scroll = stepHeights[step];
            window.currentStep = step;

            switch (step) {
                case 1:
                    break;
                case 2:

                    break;
                case 3:
                    break;
                case 4:
                    break;
                case 5:
                    speed = 1;
                    window.currentStep = 4;
                    break;
            }

            TweenMax.to(window, speed, { scrollTo: { y: scroll, autoKill: false }, onComplete: function onComplete() {
                    setTimeout(function () {
                        setAnimating(false);
                    }, 1000);
                } });
        }
    }]);

    return Home;
}();
"use strict";

var locations_filtered;

var map;
window.gm_markers = [];

function initMap() {
    if (!document.getElementById('map')) {
        return;
    }

    locations_filtered = stores;
    var zoom = 7;
    var center = new google.maps.LatLng(52.4319571, 5.1208176);

    if (window.userInfo && window.userInfo.country && window.userInfo.country.iso_code) {
        switch (window.userInfo.country.iso_code) {
            case "NL":
            case "BE":
            case "DE":
                zoom = 7;
                center = new google.maps.LatLng(52.4319571, 5.1208176);
                break;
            case "US":
            case "UM":
            case "VI":
                zoom = 4;
                center = new google.maps.LatLng(37.0902, -95.7129);
                break;
            default:
                zoom = 2;
                center = new google.maps.LatLng(52.4319571, -37.1208176);
        }
    }

    // // nl
    // var zoom = 7;
    // var center = new google.maps.LatLng(52.4319571,5.1208176);

    // // world
    // var zoom = 2;
    // var center = new google.maps.LatLng(52.4319571,-37.1208176);
    //
    // // usa
    // var zoom = 4;
    // var center = new google.maps.LatLng(37.0902,-95.7129);


    var mapOptions = {
        zoom: zoom,
        center: center,
        scrollwheel: false,
        gestureHandling: 'cooperative',
        disableDefaultUI: true,
        mapTypeControl: false,
        zoomControl: true

        //styles: [{"featureType":"administrative.locality","elementType":"geometry.fill","stylers":[{"hue":"#ff00e7"}]},{"featureType":"landscape.natural","elementType":"all","stylers":[{"visibility":"simplified"},{"lightness":"31"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"color":"#7fbebe"}]}]
    };

    map = new google.maps.Map(document.getElementById('map'), mapOptions);

    setMarkers(locations_filtered, map);
    // setMapFilters(map);

    // zoomOnMarkers(map, window.gm_markers);


    //searchbox();
};
initMap();

function setMarkers(markers, map) {
    var infowindow;

    //create all markers
    markers.forEach(function (location, index, array) {
        var image = window.template_directory_uri + '/assets/img/pointer.svg';

        var myLatLng = new google.maps.LatLng(location.latitude, location.longitude);

        var myMarker = new google.maps.Marker({
            position: myLatLng,
            map: map,
            icon: image
        });

        // window.gm_markers.push(myMarker);

        window.gm_markers[location.ID] = myMarker;

        myMarker.addListener('click', function () {
            var state = 'desktop';
            var mobileWidth = 780;
            if (window.innerWidth < mobileWidth) {
                state = 'mobile';
            }

            if (state == 'desktop') {
                $('ul.stores li').removeClass('active');
                var item = $('ul.stores li[data-id="' + location.ID + '"]');
                item.addClass('active');

                // element_position - padding + current_scroll
                var scrollTo = item.position().top - 40 + $('ul.stores').scrollTop();

                TweenMax.to($('ul.stores'), 1, { scrollTo: { y: scrollTo, autoKill: false } });
            } else {
                $('ul.stores li').removeClass('active');
                var item = $('ul.stores li[data-id="' + location.ID + '"]');
                item.addClass('active');

                // if(infowindow)
                //     infowindow.close(map);
                //
                // var contentString = '<div id="content">'+
                //     '<div class="overlay">'+
                //     '<h2>' + location.name + '</h2>';
                //
                // contentString += '<a href="'+location.url+'" class="btn btn-green">more info</a>';
                // contentString += '</div>';
                // contentString += '</div>';
                //
                // infowindow = new google.maps.InfoWindow({
                //     content: contentString,
                //     maxWidth: 320
                // });
                // infowindow.setZIndex(1);
                //
                // infowindow.open(map, myMarker);
            }
        });
    });
}

function zoomOnMarkers(map, markers) {
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < markers.length; i++) {
        bounds.extend(markers[i].getPosition());
    }

    // add padding
    bounds.b.b = bounds.b.b - 0.1;
    bounds.b.f = bounds.b.f + 0.1;

    bounds.f.b = bounds.f.b - 0.1;
    bounds.f.f = bounds.f.f + 0.1;

    map.fitBounds(bounds);
}

function zoomOnMarkerWithID(id) {
    console.log(id);
    var marker = window.gm_markers[id];
    console.log(marker);

    map.setZoom(14);
    map.panTo(marker.position);
}

function setMapFilters(map) {
    var filtered_countries = window.locations;
    var filtered_types = window.locations;

    $('.checkbox_country').click(function (e) {
        //filter countries
        filtered_countries = filterCountries(getShowCountries(), window.locations);

        filtered_types = filterTypes(getShowTypes(), filtered_countries);

        locations_filtered = filtered_types;

        clearMarkers();
        setLocationMarkers(locations_filtered, map);
    });

    $('#filter_type input').click(function (e) {
        filtered_types = filterTypes(getShowTypes(), filtered_countries);

        locations_filtered = filtered_types;

        clearMarkers();
        setLocationMarkers(locations_filtered, map);
    });
}

function clearMarkers() {
    for (var i = 0; i < window.gm_markers2.length; i++) {
        window.gm_markers2[i].setMap(null);
    }
    window.gm_markers2 = [];
}

/*
 Init showMyLocation
 */
$(function () {
    // $('#my_location').click(function () {
    //     showMyLocation();
    // });
    $('.stores li').click(function (e) {
        //e.preventDefault();

        if ($(e.currentTarget).hasClass('active')) {
            if ($(e.target).hasClass('toggle-button')) $('.stores li').removeClass('active');
        } else {
            $('.stores li').removeClass('active');
            $(e.currentTarget).addClass('active');
            zoomOnMarkerWithID($(e.currentTarget).data('id'));
        }
    });
});

var GeoMarker;
function showMyLocation(map) {
    GeoMarker = new GeolocationMarker();
    GeoMarker.setCircleOptions({ fillColor: '#808080' });

    google.maps.event.addListenerOnce(GeoMarker, 'position_changed', function () {
        map.setCenter(this.getPosition());
        map.fitBounds(this.getBounds());
        map.setZoom(12);
    });

    google.maps.event.addListener(GeoMarker, 'geolocation_error', function (e) {
        alert('There was an error obtaining your position. Message: ' + e.message);
    });

    GeoMarker.setMap(map);

    // if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition(function(position) {
    //         var myLatLng = {
    //             lat: position.coords.latitude,
    //             lng: position.coords.longitude
    //         };
    //
    //
    //         var myMarker = new google.maps.Marker({
    //             position: myLatLng,
    //             map: map,
    //             // icon: image
    //         });
    //
    //
    //         map.setCenter(myLatLng);
    //         map.setZoom(10);
    //
    //     });
    // } else{
    //     alert('Your browser does not support geolocation');
    // }

}
'use strict';

function initPhotoFeed() {
    if ($('#photo_feed--slider').length > 0) {
        $('#photo_feed--slider').slick({
            dots: true,
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            }]
        });
    }

    if ($('#collection--slider').length > 0) {
        $('#collection--slider').slick({
            dots: true,
            arrows: true,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            }]
        });
    }

    if ($('.bigslider').length > 0) {
        $('.bigslider').slick({
            dots: true,
            arrows: true,
            infinite: false,
            //speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true
        });
    }
}
'use strict';

var saveData = JSON.parse(localStorage.saveData || null) || {};
var state = {
    gender: null,
    subcollection: null,
    color_code: null,
    side: "F"
};

var feed_html = null;

var collection = {
    init: function init() {
        var self = this;

        this.initStickyMenu();

        feed_html = $('#feed').html();

        if (saveData.selectedColor) {
            self.setColor(saveData.selectedColor);
        }
        if (saveData.selectedSide) {
            self.setSide(saveData.selectedSide);
        }

        $('.checkbox button').click(function (e) {
            e.preventDefault();
            var side = $(e.target).data("side");
            self.setSide(side);
        });

        $('#color-select').change(function (e) {
            e.preventDefault();
            self.setColor(e.target.value);
        });

        $('#gender-select a').click(function (e) {
            e.preventDefault();
            $(e.target).toggleClass('active');
            var gender = $(e.target).data("gender");

            if (gender == state.gender) {
                return;
            } else {
                $('#gender-select a').removeClass('active');
                $(e.target).addClass('active');
                state.gender = gender == 'all' ? null : gender;
            }
            self.setView();
        });

        $('#collection-select a').click(function (e) {
            e.preventDefault();

            var subcollection = $(e.target).data("subcollection");

            if (subcollection == state.subcollection || subcollection == 'all') {
                return;
            } else {
                $('#collection-select a').removeClass('active');
                $(e.target).addClass('active');
                state.subcollection = subcollection == 'all' ? null : subcollection;
            }
            self.setView();
        });

        $('#feed .glasses a').click(function (e) {
            if (!saveData.selectedColor) {
                e.preventDefault();
                saveData.selectedColor = $(e.target).parent().data('color');
                localStorage.saveData = JSON.stringify(saveData);
                location.href = $(e.target).attr('href');
            }
        });
    },

    initDetailPage: function initDetailPage() {
        var self = this;

        if (saveData.selectedColor) {
            self.setColor(saveData.selectedColor);
        }
        if (saveData.selectedSide) {
            self.setSide(saveData.selectedSide);
        }

        $('.checkbox button').click(function (e) {
            e.preventDefault();
            var side = $(e.target).data("side");
            self.setSide(side);
        });

        $('#color-select').change(function (e) {
            e.preventDefault();
            self.setColor(e.target.value);
        });
    },

    setView: function setView() {
        $('#feed').html(feed_html);

        this.setColor(state.color_code);
        this.setSide(state.side);

        this.selectGender(state.gender);
        this.selectSubcollection(state.subcollection);

        $('.count').html($('.glasses').length);
    },

    setViewDetail: function setViewDetail() {
        this.setColor(state.color_code);
        this.setSide(state.side);
    },

    setColor: function setColor(color_code) {
        if (color_code == null) return;

        $('#color-select').val(color_code).trigger('change.select2');

        var side = saveData.selectedSide ? saveData.selectedSide : 'F';

        $('.glasses img, .big-glasses img').each(function () {
            var id = $(this).parent().data('id');

            if (color_code == 'random') {
                var img_url = window.rb_data.collection[id - 1].images[side][$(this).parent().data('color')];
            } else {
                var img_url = window.rb_data.collection[id - 1].images[side][color_code];
            }

            try {
                $(this).attr('src', img_url);
            } catch (e) {
                // console.log(e);
            }
        });

        saveData.selectedColor = color_code == 'random' ? null : color_code;
        localStorage.saveData = JSON.stringify(saveData);
        state.color_code = color_code;
    },

    setSide: function setSide(side) {
        if (side == null) return;

        $('.checkbox button').removeClass('checked');
        $('.checkbox button[data-side="' + side + '"]').addClass('checked');

        $('.glasses img, .big-glasses img').each(function () {
            var id = $(this).parent().data('id');

            var color_code = saveData.selectedColor && saveData.selectedColor != 'random' ? saveData.selectedColor : $(this).parent().data('color');

            var img_url = window.rb_data.collection[id - 1].images[side][color_code];

            $(this).attr('src', img_url);
        });

        saveData.selectedSide = side;
        localStorage.saveData = JSON.stringify(saveData);
        state.side = side;
    },

    selectGender: function selectGender(gender) {
        if (gender == null) return;

        $('#feed > div').not('.glasses[data-gender="' + gender + '"]').remove();

        state.gender = gender;
    },

    selectSubcollection: function selectSubcollection(subcollection) {
        if (subcollection == null) return;

        $('#feed > div').not('.glasses[data-subcollection="' + subcollection + '"]').remove();
        state.subcollection = subcollection;
    },

    initStickyMenu: function initStickyMenu() {
        return;
        var controllerSticky = new ScrollMagic.Controller();

        var duration = $('.left-nav-container--content').outerHeight() - $('.left-nav').outerHeight() + 20;

        new ScrollMagic.Scene({
            triggerElement: "#top-sticky",
            offset: -70,
            triggerHook: "onLeave",
            duration: duration
        }).setPin("#left-sticky").setClassToggle("#left-nav", "bottom") // add class toggle
        .addTo(controllerSticky);

        new ScrollMagic.Scene({
            triggerElement: "#top-sticky",
            offset: -70,
            triggerHook: "onLeave",
            duration: duration
        }).setPin("#top-sticky").addTo(controllerSticky);
    }

};
'use strict';

function initShares() {
    $('a[data-js="twitter-share"]').click(function (e) {
        var button = e.currentTarget;

        openPopup(button.href, 'twitter');

        e.preventDefault();
        return false;
    });

    $('a[data-js="facebook-share"]').click(function (e) {
        var button = e.currentTarget;

        openPopup(button.href, 'facebook');

        e.preventDefault();

        return false;
    });
}

function openPopup(url, title) {
    var w = 350;
    var h = 600;
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;

    var popup = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    if (popup && popup.focus) {
        popup.focus();
    }
}

initShares();